// hooks/useUserGroups.ts
import { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";

export const useUserGroups = () => {
  const { user } = useAuth();
  const [userGroups, setUserGroups] = useState<string[]>([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkUserGroups = async () => {
      try {
        // Get user groups from the ID token
        let idToken = "";
        const cognitoUserString = localStorage.getItem("cognitoUser");
        if (cognitoUserString) {
          const cognitoUser = JSON.parse(cognitoUserString);
          idToken = cognitoUser?.tokens?.idToken;
        }

        if (idToken) {
          try {
            // Decode the JWT token to get group information
            const payload = JSON.parse(atob(idToken.split(".")[1]));
            const groups = payload["cognito:groups"] || [];

            setUserGroups(groups);
            setIsAdmin(groups.includes("Admin"));
          } catch (decodeError) {
            console.error("Error decoding token:", decodeError);
            // Fallback: if we can't decode, assume no special permissions
            setUserGroups([]);
            setIsAdmin(false);
          }
        } else {
          // No token, not logged in
          setUserGroups([]);
          setIsAdmin(false);
        }
      } catch (error) {
        console.error("Error checking user groups:", error);
        setUserGroups([]);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    checkUserGroups();
  }, [user]);

  return { userGroups, isAdmin, loading };
};
